import React from 'react';
import Navigation from './navigation/Navigation';
import Loader from './components/Common/Loader';
import { ToastProvider } from './components/Common/Toast';
import UpdateToast from './components/Pwa/UpdateToast';

// styles
import './styles/site.css';
import './styles/responsive.css';
import './styles/mobile-overrides.css';
import './styles/components.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import { GamificationProvider } from './context/GamificationContext';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { LayoutProvider } from './context/LayoutContext';
import { ChatProvider } from './context/ChatContext';

const AppContent: React.FC = () => {
  const { loading, user } = useAuth();
  const { theme, setTheme } = useTheme();

  // Sync theme with user preferences - Only on initial load or user preferred_theme change
  React.useEffect(() => {
    if (user?.preferred_theme) {
      setTheme(user.preferred_theme);
      document.documentElement.setAttribute('data-theme', user.preferred_theme);
      localStorage.setItem('kanea_theme', user.preferred_theme);
    }
    // We intentionally omit 'theme' from dependencies to avoid reverting local changes 
    // before the backend has a chance to update.
  }, [user?.id, user?.preferred_theme, setTheme]);

  if (loading) {
    return <Loader fullScreen message="Initialisation de Kanea..." />;
  }

  return (
    <GamificationProvider>
      <Navigation />
    </GamificationProvider>
  );
};


const App: React.FC = () => (
  <ThemeProvider>
    <AuthProvider>
      <LayoutProvider>
        <ToastProvider>
          <ChatProvider>
            <AppContent />
            <UpdateToast />
          </ChatProvider>
        </ToastProvider>
      </LayoutProvider>
    </AuthProvider>
  </ThemeProvider>
);

export default App;
